const listOfValueConversion = (arr: any) => {
  if (arr.length === 0) return []
  return arr.map((v: any) => ({
    value: v,
    label: v,
  }))
}

export const conversionData = (data: any, isCustom: boolean) => {
  if (!data && data.length === 0) {
    return []
  }

  let fields: any = []
  data.forEach((item: any) => {
    let params:any = {}
    params.isB3User = true
    params.custom = isCustom
    params.name = `${item.fieldName}`
    params.label = item.fieldName
    params.val = item?.defaultValue || ''
    params.default = item?.defaultValue || ''
    params.required = item.isRequired
    params.id = `${item.fieldName}`
    params.visibleToEnduser = item.visibleToEnduser
    if (item.fieldType === 0) {
      params.fieldType = 'text'
      params.type = "string"
      params.max = item.maximumLength
      params.maxLength = item.maximumLength
    } else if (item.fieldType === 1) {
      params.fieldType = 'multiline'
      params.type = "string"
      params.options = {rows: item?.numberOfRows + '' || '5'}
    } else if (item.fieldType === 2) {
      params.fieldType = 'text'
      params.type = "integer"
      params.max = item.maximumValue && +item.maximumValue
      params.maxLength = item.maximumValue && +item.maximumValue
    } else if (item.fieldType === 3) {
      params.fieldType = 'dropdown'
      params.type = "array"
      params.options = {
        helperLabel: 'Please Select',
        items: item?.listOfValue ? listOfValueConversion(item.listOfValue) : []
      }
    }
    fields.push(params)
  }) 
  return fields
}